import React from "react";

export default function NextButtonComponent(
    {
        text = "Next",
        onClick,
        disabled = false,
        additionalCssClasses = '',
       iconPosition = 'right',
       iconClass = 'fa fa-fw fa-chevron-right',
        ...rest
    }
) {

   iconPosition = typeof iconPosition === 'string' ? iconPosition.trim() : 'right';
   
   if(['left','right'].includes(iconPosition) === false) {
      iconPosition = 'right';
   }
   
   iconClass = typeof iconClass === 'string' ? iconClass.trim() : 'fa fa-chevron-right';
   
    return (
        <button
            type="button"
            className={`btn btn-success btn-steps mb-3 min-width-200px ${additionalCssClasses}`}
            disabled={disabled}
            onClick={onClick}
            {...rest}
        >
           
           {iconPosition === 'left' && iconClass !== '' && <i className={iconClass}/>}
           
            {text}
           
           {iconPosition === 'right' && iconClass !== '' && <i className={iconClass}/>}
        </button>
    );

}